export const getFontUrl = (
  fontPath: string,
  cdnBaseUrl: string = import.meta.env.VITE_WIDGET_CDN_BASE_URL
) =>
  fontPath.startsWith("organization/")
    ? `${cdnBaseUrl}/${fontPath}`
    : `${cdnBaseUrl}/assets/fonts/${fontPath}`;
